import { useEffect, useState } from "react";
import { getCurrentDocumentAccess } from "./service/DocumentAccessService";
const denied = { view: false, review: false, can_manage: false };
// Menu visibility is advisory. Every data request is authorized by the backend.
export default function useDocumentAccess(enabled, refreshKey) {
  const [access, setAccess] = useState(denied);
  useEffect(() => {
    let active = true;
    let sequence = 0;
    setAccess(denied);
    if (!enabled) return;
    const refresh = async () => {
      const current = ++sequence;
      try {
        const value = await getCurrentDocumentAccess();
        if (active && current === sequence) setAccess(value);
      } catch {
        if (active && current === sequence) setAccess(denied);
      }
    };
    refresh();
    const timer = setInterval(refresh, 30000);
    window.addEventListener("focus", refresh);
    window.addEventListener("company-document-access-changed", refresh);
    return () => {
      active = false;
      clearInterval(timer);
      window.removeEventListener("focus", refresh);
      window.removeEventListener("company-document-access-changed", refresh);
    };
  }, [enabled, refreshKey]);
  return access;
}
